// 华龙酸菜旧版产品ID映射表
// 旧版URL格式: https://h5-hualong.vdvq.com/#/trace?product=35
// 新版URL格式: https://zsh5.tvtvc.com/#/trace?product_id=<uuid>

// 生产库 UUID（36位带连字符）
const PROD_UUID_MAP = {
  25: { name: '酸菜笋丁牛肉酱（香辣）40克',       uuid: '9432300a-a669-43ae-9e6c-c6ec0ca3b1d5' },
  26: { name: '酸菜笋丁牛肉酱（原味）40克',       uuid: 'e4d834a4-101e-4adf-8dfa-55fbd5d12449' },
  27: { name: '酸菜香菇牛肉酱（香辣）40克',       uuid: 'a5d56fde-3e19-4dbb-b3d2-3f569b8e3337' },
  28: { name: '酸菜香菇牛肉酱（原味）40克',       uuid: 'c5b8c947-4505-4727-a660-06e02ba61463' },
  29: { name: '酸菜牛肉酱（香辣）40克',           uuid: '622ad9bb-4660-41de-a8ad-9063f0d837ad' },
  30: { name: '酸菜牛肉酱（原味）40克',           uuid: '66b2c697-b418-4974-925f-8092d40a400b' },
  31: { name: '酸菜香菇（香辣）40克',             uuid: '8dabb233-46d9-4778-92a9-dad655a84dac' },
  32: { name: '酸菜脆笋40克',                    uuid: 'b052b11d-357f-4264-b759-0517d0510907' },
  33: { name: '酸菜香菇（原味）40克',             uuid: 'bc758b93-ce3e-4c68-8d25-89dc6e8293ac' },
  34: { name: '相不辣下饭菜40克',                 uuid: '45dadff0-e95c-49f6-a7ae-cbd711f6a6b1' },
  35: { name: '净酸菜（238g）',              uuid: '32951447-b991-4a49-be62-24675aeab77a' },
  36: { name: '酸菜脆笋（80g）',             uuid: 'f28ecbe6-01bf-49e2-8066-f760b1bc83b5' },
  37: { name: '酸菜香菇原味（80g）',         uuid: '22b0d765-3302-4076-94b2-a32f55c7768b' },
  38: { name: '酸菜牛肉酱香辣（80g）',       uuid: '35809ac6-afa8-46f0-a6b8-c62a4fc3f316' },
  39: { name: '酸菜牛肉酱原味（80g）',       uuid: '210a751f-ab97-45ac-ad19-7253af046a84' },
  40: { name: '酸菜香菇牛肉酱原味（80g/袋）', uuid: '66150aef-0b6c-4087-b179-7678303b6831' },
  41: { name: '酸菜牛肉酱香辣（230g/瓶）',   uuid: '0f2ba887-948c-4464-92f2-7689413f7f56' },
  42: { name: '酸菜牛肉酱原味（230g/瓶）',   uuid: '77456726-c5c0-4b3c-9802-0905cd615382' }
}

// 测试库 UUID（32位无连字符，测试环境 trace_product.id 格式不同）
const TEST_UUID_MAP = {
  25: { name: '酸菜笋丁牛肉酱（香辣）40克',       uuid: '22f84b87-5cc3-460a-8c75-9ce3a00004bb' },
  26: { name: '酸菜笋丁牛肉酱（原味）40克',       uuid: 'a698be00-aa63-4d74-b31c-a6b647c5eb1a' },
  27: { name: '酸菜香菇牛肉酱（香辣）40克',       uuid: 'dbaeaf18-4f47-4cd6-ab23-e9ef54ca297c' },
  28: { name: '酸菜香菇牛肉酱（原味）40克',       uuid: '8a4ca81e-c4b0-482b-9237-ee03f976790c' },
  29: { name: '酸菜牛肉酱（香辣）40克',           uuid: '8c0e1fe5-034f-44cc-b1e6-f2c5c017fdc4' },
  30: { name: '酸菜牛肉酱（原味）40克',           uuid: 'f83937c8-a119-429e-a589-198a4c4770f5' },
  31: { name: '酸菜香菇（香辣）40克',             uuid: '318cbae4-21d9-4953-8197-d0f8f86f2033' },
  32: { name: '酸菜脆笋40克',                    uuid: '82e41cc2-5525-4ef7-a234-612d89ee0333' },
  33: { name: '酸菜香菇（原味）40克',             uuid: '204fda8c-6923-4962-82b0-84421b27694a' },
  34: { name: '相不辣下饭菜40克',                 uuid: '248dc30b-b6e3-484a-bd36-dca1abc3a919' },
  35: { name: '净酸菜（238g）',              uuid: '32951447b99111efb01800163e0c6a17' },
  36: { name: '酸菜脆笋（80g）',             uuid: 'f28ecbe601bf11f0b01800163e0c6a17' },
  37: { name: '酸菜香菇原味（80g）',         uuid: '22b0d7653302110fb01800163e0c6a17' },
  38: { name: '酸菜牛肉酱香辣（80g）',       uuid: '35809ac6afa811efb01800163e0c6a17' },
  39: { name: '酸菜牛肉酱原味（80g）',       uuid: '210a751fab9711efb01800163e0c6a17' },
  40: { name: '酸菜香菇牛肉酱原味（80g/袋）', uuid: '66150aef0b6c11f0b01800163e0c6a17' },
  41: { name: '酸菜牛肉酱香辣（230g/瓶）',   uuid: '0f2ba887948c11efb01800163e0c6a17' },
  42: { name: '酸菜牛肉酱原味（230g/瓶）',   uuid: '77456726c5c011efb01800163e0c6a17' }
}

// ERP goods_id 映射（trace_product.product_id 存的是 goods_id）
// 测试环境：goods_id 1213-1220 对应旧版 ID 35-42
const GOODS_ID_MAP_TEST = {
  1213: 35, 1214: 36, 1215: 37, 1216: 38,
  1217: 39, 1218: 40, 1219: 41, 1220: 42
}

// 生产环境：goods_id 1895-1902 对应旧版 ID 35-42
const GOODS_ID_MAP_PROD = {
  1895: 35, 1896: 36, 1897: 37, 1898: 38,
  1899: 39, 1900: 40, 1901: 41, 1902: 42
}

// 根据构建时注入的环境变量选择映射表
// .env.hualong_test  → VUE_APP_LEGACY_UUID_ENV=test
// .env.hualong_prod  → VUE_APP_LEGACY_UUID_ENV=prod（或未设置）
const LEGACY_PRODUCT_MAP =
  process.env.VUE_APP_LEGACY_UUID_ENV === 'test' ? TEST_UUID_MAP : PROD_UUID_MAP

const GOODS_ID_MAP =
  process.env.VUE_APP_LEGACY_UUID_ENV === 'test' ? GOODS_ID_MAP_TEST : GOODS_ID_MAP_PROD

/**
 * 判断是否是旧版整数产品ID
 */
export function isLegacyProductId(val) {
  const num = parseInt(val, 10)
  return !isNaN(num) && String(num) === String(val) && LEGACY_PRODUCT_MAP[num] !== undefined
}

/**
 * 获取旧版产品名称（用于日志）
 */
export function getLegacyProductName(val) {
  const num = parseInt(val, 10)
  return (LEGACY_PRODUCT_MAP[num] && LEGACY_PRODUCT_MAP[num].name) || '未知产品'
}

/**
 * 从URL参数中解析产品ID，返回 { paramName, paramValue } 或 null
 *
 * 支持:
 *   ?product_id=<uuid>  新版 → { paramName: 'product_id', paramValue: '<uuid>' }
 *   ?product=<integer>  旧版 → { paramName: 'product', paramValue: 35 }
 *
 * 映射优先级（华龙商户）:
 *   1. 旧版整数 ID（35-42）→ UUID
 *   2. 当前环境 goods_id（测试 1213-1220，生产 1895-1902）→ 旧版 ID → UUID
 *   3. 其他整数 → 直接当 product_id
 */
export function parseProductId() {
  // Hash 路由：参数在 hash 里（/#/trace?product=35），不在 search 里
  const hash = window.location.hash || ''
  const queryStr = hash.includes('?') ? hash.split('?')[1] : ''
  const urlParams = new URLSearchParams(queryStr)
  const productId = urlParams.get('product_id')
  const legacyProduct = urlParams.get('product')

  if (productId) {
    return { paramName: 'product_id', paramValue: productId }
  }

  if (legacyProduct) {
    const num = parseInt(legacyProduct, 10)
    if (!isNaN(num)) {
      // 优先级1: 旧版整数 ID（35-42）直接映射
      if (LEGACY_PRODUCT_MAP[num]) {
        return { paramName: 'product_id', paramValue: LEGACY_PRODUCT_MAP[num].uuid }
      }

      // 优先级2: goods_id（1213-1220 等）先转旧版ID，再映射UUID
      if (GOODS_ID_MAP[num]) {
        const legacyId = GOODS_ID_MAP[num]
        if (LEGACY_PRODUCT_MAP[legacyId]) {
          console.log(`[华龙酸菜] goods_id ${num} → 旧版ID ${legacyId} → ${LEGACY_PRODUCT_MAP[legacyId].name}`)
          return { paramName: 'product_id', paramValue: LEGACY_PRODUCT_MAP[legacyId].uuid }
        }
      }
    }

    // 优先级3: 非华龙商户，兜底当作普通 product_id 使用（保持旧版行为）
    return { paramName: 'product_id', paramValue: legacyProduct }
  }

  return null
}
